import { StripeProductTemplateFromJSON, StripeProductTemplateToJSON, } from './StripeProductTemplate';
/**
 * Check if a given object implements the CreateStripeProductRequest interface.
 */
export function instanceOfCreateStripeProductRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "template" in value;
    return isInstance;
}
export function CreateStripeProductRequestFromJSON(json) {
    return CreateStripeProductRequestFromJSONTyped(json, false);
}
export function CreateStripeProductRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'template': StripeProductTemplateFromJSON(json['template']),
    };
}
export function CreateStripeProductRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'template': StripeProductTemplateToJSON(value.template),
    };
}
